// Work with me: turn each H2 and the text under it into a card with an icon.
// Meghan keeps writing plain headings and paragraphs in the editor.
const ICONS = [
    [/train|workshop|team|teach|course/i, "graduation"],
    [/consult|expert|review|investigat|litigat/i, "helmet"],
    [/coach|career|mentor|one[- ]to[- ]one|1:1/i, "lightbulb"],
    [/speak|keynote|talk|present/i, "microphone"],
    [/writ|editor/i, "book"],
];

export default function services() {
    const root = document.querySelector("[data-services]");
    if (!root) return;
    const heads = [...root.querySelectorAll("h2")];
    if (heads.length < 2) return;

    const sprite = document.body.dataset.icons;
    const icon = (name) => (sprite ? `<svg class="ci" aria-hidden="true"><use href="${sprite}#${name}"/></svg>` : "");

    const grid = document.createElement("div");
    grid.className = "gh-services kg-width-wide";
    heads[0].before(grid);

    heads.forEach((h) => {
        const card = document.createElement("div");
        card.className = "service-card";
        const hit = ICONS.find(([re]) => re.test(h.textContent));
        if (hit) {
            const span = document.createElement("span");
            span.className = "service-icon";
            span.innerHTML = icon(hit[1]);
            card.appendChild(span);
        }
        // Move the heading and everything up to the next H2 into the card
        const parts = [h];
        let n = h.nextElementSibling;
        while (n && n.tagName !== "H2") { parts.push(n); n = n.nextElementSibling; }
        parts.forEach((el) => card.appendChild(el));
        grid.appendChild(card);
    });
}
